<template>
  <div id="web-layout">
    <!-- web header -->
    <WebLayoutHeader />
    <!-- <MyEditor /> -->

    <!-- web content -->
    <!-- <WebLayoutContent /> -->

    <!-- web footer -->
    <!-- <WebLayoutFooter /> -->
  </div>
</template>

<style>
  @import "./../assets/web/css/layout.css";
  @import "./../assets/web/css/header.css";
  @import "./../assets/web/css/newsContent.css";
  @import "./../assets/web/css/newsInfo.css";
  @import "./../assets/web/css/newsList.css";
  /* @import "./../assets/web/css/content.css"; */
  @import "./../assets/web/css/footer.css";
  @import "./../assets/widget/css/widget.css";
  @import "./../assets/icon/css/icon.css";
  @import "./../assets/table/css/table.css";
</style>

<script>
  import WebLayoutHeader from "./layout/Header.vue";
  // import MyEditor from "./layout/MyEditor.vue"
  // import WebLayoutContent from "./layout/Content.vue";
  // import WebLayoutFooter from "./layout/Footer.vue";

  export default {
    name: "WebLayout",
    components: {
      WebLayoutHeader: WebLayoutHeader,
      // MyEditor: MyEditor
      // WebLayoutContent: WebLayoutContent,
      /* eslint-disable */
      // WebLayoutFooter: WebLayoutFooter
    },
    data() {
      return {
        project: ""
      }
    },
    /* eslint-disable */
    created() {
    },
    methods: {

    }
  };
</script>